import type { CommunicationDetails } from '../communications/types';
import type { ApiDocument, ApiDocumentFilters } from '../documents/types';

export const sharedItemsCollection = {
  EXPIRING_COMMUNICATION_DETAILS: 'EXPIRING_COMMUNICATION_DETAILS',
  NOT_EXPIRING_COMMUNICATION_DETAILS: 'NOT_EXPIRING_COMMUNICATION_DETAILS',
  PUSHED_DOCUMENTS: 'PUSHED_DOCUMENTS',
  SHARED_DOCUMENTS: 'SHARED_DOCUMENTS',
} as const;

export type SharedItemsCollection = keyof typeof sharedItemsCollection;

export type SharedApiCommonQueryParams = {
  searchTerm?: string;
  ownerId?: string;
  labels?: Array<string>;
};

export type SharedApiCommonMetadata = ApiDocumentFilters & {
  numberUnseenCommunications: number;
  numberUnseenExpiringCommunications: number;
  numberPendingPushedDocuments: number;
};

export type SharedItemsReturnType = CommunicationDetails | ApiDocument;
